export const navigation = [
  {
    text: 'SIDENAV.DASHBOARD',
    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8335 17.5H4.16683C3.94582 17.5 3.73385 17.4122 3.57757 17.2559C3.42129 17.0996 3.3335 16.8877 3.3335 16.6666V9.16664H0.833496L9.43933 1.34331C9.59275 1.20371 9.79273 1.12634 10.0002 1.12634C10.2076 1.12634 10.4076 1.20371 10.561 1.34331L19.1668 9.16664H16.6668V16.6666C16.6668 16.8877 16.579 17.0996 16.4228 17.2559C16.2665 17.4122 16.0545 17.5 15.8335 17.5ZM5.00016 15.8333H15.0002V7.63081L10.0002 3.08581L5.00016 7.63081V15.8333ZM6.66683 12.5H13.3335V14.1666H6.66683V12.5Z" fill="currentColor"/></svg>`,
    path: '/dashboard',
  },
  {
    text: 'SIDENAV.TRAININGS',
    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1665 2.49998H17.4998C17.7209 2.49998 17.9328 2.58778 18.0891 2.74406C18.2454 2.90034 18.3332 3.1123 18.3332 3.33331V16.6666C18.3332 16.8877 18.2454 17.0996 18.0891 17.2559C17.9328 17.4122 17.7209 17.5 17.4998 17.5H2.49984C2.27882 17.5 2.06686 17.4122 1.91058 17.2559C1.7543 17.0996 1.6665 16.8877 1.6665 16.6666V3.33331C1.6665 3.1123 1.7543 2.90034 1.91058 2.74406C2.06686 2.58778 2.27882 2.49998 2.49984 2.49998H5.83317V0.833313H7.49984V2.49998H12.4998V0.833313H14.1665V2.49998ZM16.6665 9.16665H3.33317V15.8333H16.6665V9.16665ZM12.4998 4.16665H7.49984V5.83331H5.83317V4.16665H3.33317V7.49998H16.6665V4.16665H14.1665V5.83331H12.4998V4.16665ZM4.99984 10.8333H6.6665V12.5H4.99984V10.8333ZM9.1665 10.8333H10.8332V12.5H9.1665V10.8333ZM13.3332 10.8333H14.9998V12.5H13.3332V10.8333Z" fill="currentColor"/></svg>`,
    items: [
      {
        text: 'SIDENAV.MY-TRAININGS',
        path: '/my-trainings',
      },
      {
        text: 'SIDENAV.LEARNING-PATHS',
        path: '/learning-paths',
      },
      {
        text: 'SIDENAV.TRAINING-CATALOGUE',
        path: '/training-catalogue',
      },
      {
        text: 'SIDENAV.CALENDAR',
        path: '/training-calendar',
      },
    ],
  },
  {
    text: 'SIDENAV.TRAINING-MANAGEMENT',
    icon: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Laptop body -->
        <rect x="3" y="5" width="18" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
        <!-- Laptop base/feet -->
        <line x1="5" y1="19" x2="19" y2="19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        
        <!-- Checklist on screen -->
        <path d="M6 8L7 9L9 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="10" y1="8" x2="14" y2="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        
        <path d="M6 11L7 12L9 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="10" y1="11" x2="14" y2="11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        
        <!-- Graduation cap -->
        <g transform="translate(19 1) rotate(15) scale(1.3)">
          <path d="M0 0L-4 1.6L0 3.2L4 1.6L0 0Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
          <path d="M-2.5 3.1V4.6C-2.5 5.3 -1.1 6 0 6C1.1 6 2.5 5.3 2.5 4.6V3.1" stroke="currentColor" stroke-width="1.4"/>
        </g>
      </svg>
    `,
    items: [
      {
        text: 'SIDENAV.MANAGE-TRAININGS',
        path: '/training',
      },
      {
        text: 'SIDENAV.MANAGE-ELEARNING',
        path: '/manage-elearning',
      },
      {
        text: 'SIDENAV.MANAGE-COMPLIANCE',
        path: '/manage-compliance',
      },
      {
        text: 'SIDENAV.MANAGE-LEARNING-PATH',
        path: '/manage-learning-path',
      },
      {
        text: 'SIDENAV.ADMINISTRATION',
        path: '/administration',
      },
    ],
  },

  {
    text: 'SIDENAV.ORGANIZATION',
    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M7.94667 10.8333H6.1075C5.76417 11.805 4.83833 12.5 3.75 12.5C2.36917 12.5 1.25 11.3808 1.25 10C1.25 8.61917 2.36917 7.5 3.75 7.5C4.83833 7.5 5.765 8.19583 6.10833 9.16667H7.94667L10.8333 4.16667H13.475C13.8183 3.19583 14.745 2.5 15.8333 2.5C17.2142 2.5 18.3333 3.61917 18.3333 5C18.3333 6.38083 17.2142 7.5 15.8333 7.5C14.745 7.5 13.8192 6.805 13.4758 5.83333H11.795L9.39 9.99917L11.7958 14.1667H13.4758C13.8183 13.1958 14.745 12.5 15.8333 12.5C17.2142 12.5 18.3333 13.6192 18.3333 15C18.3333 16.3808 17.2142 17.5 15.8333 17.5C14.745 17.5 13.8192 16.805 13.4758 15.8333H10.8333L7.94667 10.8333ZM15.8333 14.1667C15.3733 14.1667 15 14.54 15 15C15 15.46 15.3733 15.8333 15.8333 15.8333C16.2933 15.8333 16.6667 15.46 16.6667 15C16.6667 14.54 16.2933 14.1667 15.8333 14.1667ZM3.75 9.16667C3.29 9.16667 2.91667 9.54 2.91667 10C2.91667 10.46 3.29 10.8333 3.75 10.8333C4.21 10.8333 4.58333 10.46 4.58333 10C4.58333 9.54 4.21 9.16667 3.75 9.16667ZM15.8333 4.16667C15.3733 4.16667 15 4.54 15 5C15 5.46 15.3733 5.83333 15.8333 5.83333C16.2933 5.83333 16.6667 5.46 16.6667 5C16.6667 4.54 16.2933 4.16667 15.8333 4.16667Z" fill="currentColor"/></g></svg>`,
    path: '',
    expanded: false,
    items: [
      {
        text: 'SIDENAV.STRUCTURE',
        path: '/organisation-unit',
      },
      {
        text: 'SIDENAV.EMPLOYEES',
        path: '/employee',
      },
      /*
      {
        text: 'SIDENAV.EXTERNAL-CONTACTS',
        path: '/external-contacts',
      },
      */
      {
        text: 'SIDENAV.REGISTRATION-LINKS',
        path: '/registration-links',
      },
    ],
  },
  {
    text: 'SIDENAV.SETTINGS',
    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><path id="Vector" d="M5.1415 15C5.31367 14.512 5.63295 14.0895 6.05534 13.7906C6.47772 13.4918 6.98241 13.3313 7.49984 13.3313C8.01727 13.3313 8.52195 13.4918 8.94434 13.7906C9.36672 14.0895 9.686 14.512 9.85817 15H18.3332V16.6667H9.85817C9.686 17.1546 9.36672 17.5771 8.94434 17.876C8.52195 18.1749 8.01727 18.3354 7.49984 18.3354C6.98241 18.3354 6.47772 18.1749 6.05534 17.876C5.63295 17.5771 5.31367 17.1546 5.1415 16.6667H1.6665V15H5.1415ZM10.1415 9.16665C10.3137 8.67871 10.633 8.25618 11.0553 7.95731C11.4777 7.65844 11.9824 7.49794 12.4998 7.49794C13.0173 7.49794 13.522 7.65844 13.9443 7.95731C14.3667 8.25618 14.686 8.67871 14.8582 9.16665H18.3332V10.8333H14.8582C14.686 11.3213 14.3667 11.7438 13.9443 12.0427C13.522 12.3415 13.0173 12.502 12.4998 12.502C11.9824 12.502 11.4777 12.3415 11.0553 12.0427C10.633 11.7438 10.3137 11.3213 10.1415 10.8333H1.6665V9.16665H10.1415ZM5.1415 3.33332C5.31367 2.84538 5.63295 2.42285 6.05534 2.12398C6.47772 1.82511 6.98241 1.66461 7.49984 1.66461C8.01727 1.66461 8.52195 1.82511 8.94434 2.12398C9.36672 2.42285 9.686 2.84538 9.85817 3.33332H18.3332V4.99999H9.85817C9.686 5.48793 9.36672 5.91046 8.94434 6.20933C8.52195 6.5082 8.01727 6.6687 7.49984 6.6687C6.98241 6.6687 6.47772 6.5082 6.05534 6.20933C5.63295 5.91046 5.31367 5.48793 5.1415 4.99999H1.6665V3.33332H5.1415ZM7.49984 4.99999C7.72085 4.99999 7.93281 4.91219 8.08909 4.75591C8.24537 4.59963 8.33317 4.38767 8.33317 4.16665C8.33317 3.94564 8.24537 3.73368 8.08909 3.5774C7.93281 3.42112 7.72085 3.33332 7.49984 3.33332C7.27882 3.33332 7.06686 3.42112 6.91058 3.5774C6.7543 3.73368 6.6665 3.94564 6.6665 4.16665C6.6665 4.38767 6.7543 4.59963 6.91058 4.75591C7.06686 4.91219 7.27882 4.99999 7.49984 4.99999ZM12.4998 10.8333C12.7209 10.8333 12.9328 10.7455 13.0891 10.5892C13.2454 10.433 13.3332 10.221 13.3332 9.99999C13.3332 9.77897 13.2454 9.56701 13.0891 9.41073C12.9328 9.25445 12.7209 9.16665 12.4998 9.16665C12.2788 9.16665 12.0669 9.25445 11.9106 9.41073C11.7543 9.56701 11.6665 9.77897 11.6665 9.99999C11.6665 10.221 11.7543 10.433 11.9106 10.5892C12.0669 10.7455 12.2788 10.8333 12.4998 10.8333ZM7.49984 16.6667C7.72085 16.6667 7.93281 16.5789 8.08909 16.4226C8.24537 16.2663 8.33317 16.0543 8.33317 15.8333C8.33317 15.6123 8.24537 15.4003 8.08909 15.2441C7.93281 15.0878 7.72085 15 7.49984 15C7.27882 15 7.06686 15.0878 6.91058 15.2441C6.7543 15.4003 6.6665 15.6123 6.6665 15.8333C6.6665 16.0543 6.7543 16.2663 6.91058 16.4226C7.06686 16.5789 7.27882 16.6667 7.49984 16.6667Z" fill="currentColor"/></g></svg>`,
    path: '',
    expanded: false,
    items: [
      {
        text: 'SIDENAV.GENERAL',
        path: '/settings',
      },
      {
        text: 'SIDENAV.INTEGRATIONS',
        path: '/integrations',
      },
      {
        text: 'SIDENAV.SUBSCRIPTIONS',
        path: '/subscriptions',
      },
      {
        text: 'SIDENAV.ACTIVITY-LOG',
        path: '/activity-log',
      },
    ],
  },
];
